import React, { useEffect } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { object, string } from "yup";
import { Formik } from "formik";
import { API } from "../../../api/API";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Button from "@mui/material/Button";
import { Box, Typography } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import Divider from "@mui/material/Divider";
import { appColors } from "../../../constant/constant";
import useAuthStore from "../../../store/authStore";

const RegisterStructure = ({ handleRefresh }) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const user = useAuthStore((state) => state.user);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);

  // Schéma de validation pour les structures
  const structureSchema = object({
    intitule: string().required("Ce champ est requis"),
    rccm: string().required("Ce champ est requis"),
    ifu: string().required("Ce champ est requis"),
    tel: string()
      .required("Ce champ est requis")
      .matches(/^[0-9]+$/, "Doit contenir uniquement des chiffres")
      .min(8, "Doit contenir au moins 8 chiffres"),
    adresse: string().required("Ce champ est requis"),
    email: string().email("Email invalide").required("Ce champ est requis"),
  });

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />

      <Button
        variant="outlined"
        color="success"
        sx={{
          "&:hover": { backgroundColor: "#2e8b3a" },
          borderRadius: "8px",
          padding: "8px 16px",
          textTransform: "none",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
        onClick={handleShow}
        startIcon={<span style={{ fontSize: "1.2rem" }}>+</span>}
      >
        <Typography variant="subtitle1"> Structure</Typography>
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-success text-light">
          <Modal.Title id="contained-modal-title-vcenter">
            <Typography variant="h6" component="h2" color="inherit">
              Enregistrement d'une nouvelle structure
            </Typography>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Box sx={{ maxHeight: "70vh", overflowY: "auto", padding: "0 16px" }}>
            <Formik
              validationSchema={structureSchema}
              initialValues={{
                intitule: "",

                rccm: "",
                ifu: "",
                tel: "",
                adresse: "",
                email: "",
              }}
              onSubmit={async (values, { setSubmitting, resetForm }) => {
                const toastId = toast.loading("Enregistrement en cours...");
                try {
                  const resp = await API.post("/structures", {
                    ...values,
                    created_by: user?.id,
                  });
                  toast.update(toastId, {
                    render: "Structure créée avec succès!",
                    type: "success",
                    isLoading: false,
                    autoClose: 5000,
                  });
                  handleRefresh();
                  resetForm();
                  handleClose();
                } catch (error) {
                  let errorMessage =
                    "Erreur lors de la création de la structure";

                  if (error.response) {
                    errorMessage =
                      error.response.data.message ||
                      `${error.response.status}: ${JSON.stringify(
                        error.response.data.error
                      )}`;
                  } else if (error.request) {
                    errorMessage = "Pas de réponse du serveur";
                  }

                  toast.update(toastId, {
                    render: errorMessage,
                    type: "error",
                    isLoading: false,
                    autoClose: 5000,
                  });
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                resetForm,
                isSubmitting,
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <Divider sx={{ color: appColors.secondary }}>
                    Informations de la structure
                  </Divider>

                  <Row className="mb-3">
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Intitulé <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="intitule"
                        required
                        type="text"
                        value={values.intitule}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Intitulé de la structure"
                        isInvalid={touched.intitule && !!errors.intitule}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.intitule}
                      </Form.Control.Feedback>
                    </Form.Group>

                    {/* <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Code <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="code"
                        required
                        type="text"
                        value={values.code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Code de la structure"
                        isInvalid={touched.code && !!errors.code}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.code}
                      </Form.Control.Feedback>
                    </Form.Group> */}
                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        RCCM <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="rccm"
                        required
                        type="text"
                        value={values.rccm}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="RCCM"
                        isInvalid={touched.rccm && !!errors.rccm}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.rccm}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        IFU <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="ifu"
                        required
                        type="text"
                        value={values.ifu}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="IFU"
                        isInvalid={touched.ifu && !!errors.ifu}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.ifu}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Téléphone <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="tel"
                        required
                        type="tel"
                        value={values.tel}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Téléphone"
                        isInvalid={touched.tel && !!errors.tel}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.tel}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Adresse <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="adresse"
                        required
                        type="text"
                        value={values.adresse}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Adresse"
                        isInvalid={touched.adresse && !!errors.adresse}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.adresse}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} md={12} className="mb-3">
                      <Form.Label>
                        Email <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="email"
                        required
                        type="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Email"
                        isInvalid={touched.email && !!errors.email}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 2,
                      mt: 3,
                    }}
                  >
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={handleClose}
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "6px 16px",
                      }}
                    >
                      Annuler
                    </Button>

                    <Button
                      variant="outlined"
                      color="info"
                      onClick={() => resetForm()}
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "6px 16px",
                      }}
                    >
                      Réinitialiser
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      disabled={isSubmitting}
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "6px 24px",
                        backgroundColor: "#37B049",
                        "&:hover": { backgroundColor: "#2e8b3a" },
                      }}
                    >
                      {isSubmitting ? "Enregistrement..." : "Enregistrer"}
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RegisterStructure;
